import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import { BacklogApiAuthenticationError } from "./BacklogApiAuthenticationError";
import type { BacklogApiErrorDetailList } from "./BacklogApiErrorDetailList";

export class BacklogApiAuthenticationInvalidTokenError extends BacklogApiAuthenticationError {
	constructor(options: {
		response: BacklogHttpResponse;
		error_details: BacklogApiErrorDetailList;
	}) {
		super({
			response: options.response,
			error_details: options.error_details,
			message: "BacklogApiAuthenticationInvalidTokenError",
		});
	}
}
